import "core-js/modules/es.array.join.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "process-tracker"
  }, [_c('div', {
    staticClass: "tracker-toolbar"
  }, [_c('div', {
    staticClass: "info-area"
  }, [_vm.currentActivityNames.length ? _c('a-tag', {
    attrs: {
      "color": "green"
    }
  }, [_c('a-icon', {
    attrs: {
      "type": "dingding"
    }
  }), _vm._v(" 当前节点：" + _vm._s(_vm.currentActivityNames.join('、')) + " ")], 1) : _vm.finished ? _c('a-tag', {
    attrs: {
      "color": "orange"
    }
  }, [_c('a-icon', {
    attrs: {
      "type": "check-circle"
    }
  }), _vm._v(" 流程已结束 ")], 1) : _vm._e()], 1), _c('div', {
    staticClass: "actions"
  }, [_c('a-button-group', [_c('a-button', {
    attrs: {
      "size": "small",
      "title": "放大"
    },
    on: {
      "click": _vm.zoomIn
    }
  }, [_c('a-icon', {
    attrs: {
      "type": "zoom-in"
    }
  })], 1), _c('a-button', {
    attrs: {
      "size": "small",
      "title": "缩小"
    },
    on: {
      "click": _vm.zoomOut
    }
  }, [_c('a-icon', {
    attrs: {
      "type": "zoom-out"
    }
  })], 1), _c('a-button', {
    attrs: {
      "size": "small",
      "title": "适应画布"
    },
    on: {
      "click": _vm.resetZoom
    }
  }, [_c('a-icon', {
    attrs: {
      "type": "arrows-alt"
    }
  })], 1), _c('a-button', {
    attrs: {
      "size": "small",
      "title": "刷新"
    },
    on: {
      "click": _vm.refresh
    }
  }, [_c('a-icon', {
    attrs: {
      "type": "reload"
    }
  })], 1)], 1)], 1)]), _c('div', {
    ref: "canvasRef",
    staticClass: "bpmn-canvas"
  }), _vm.loading ? _c('div', {
    staticClass: "loading-mask"
  }, [_c('a-spin', {
    attrs: {
      "tip": "加载流程图..."
    }
  })], 1) : _vm._e(), _vm.errorMsg ? _c('div', {
    staticClass: "error-mask"
  }, [_c('a-alert', {
    attrs: {
      "message": _vm.errorMsg,
      "type": "error",
      "show-icon": ""
    }
  })], 1) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };